export interface Country {
  code: string
  name: string
  phoneCode: string
  nationality: string
  flag: string
}

export const countries: Country[] = [
  // África
  { code: 'ST', name: 'São Tomé e Príncipe', phoneCode: '+239', nationality: 'São Tomé e Príncipe', flag: '🇸🇹' },
  { code: 'AO', name: 'Angola', phoneCode: '+244', nationality: 'Angolana', flag: '🇦🇴' },
  { code: 'MZ', name: 'Moçambique', phoneCode: '+258', nationality: 'Moçambicana', flag: '🇲🇿' },
  { code: 'CV', name: 'Cabo Verde', phoneCode: '+238', nationality: 'Cabo-verdiana', flag: '🇨🇻' },
  { code: 'GW', name: 'Guiné-Bissau', phoneCode: '+245', nationality: 'Guineense', flag: '🇬🇼' },
  { code: 'GQ', name: 'Guiné Equatorial', phoneCode: '+240', nationality: 'Guinéu-equatoriana', flag: '🇬🇶' },
  { code: 'ZA', name: 'África do Sul', phoneCode: '+27', nationality: 'Sul-africana', flag: '🇿🇦' },
  { code: 'NG', name: 'Nigéria', phoneCode: '+234', nationality: 'Nigeriana', flag: '🇳🇬' },
  { code: 'KE', name: 'Quénia', phoneCode: '+254', nationality: 'Queniana', flag: '🇰🇪' },
  { code: 'EG', name: 'Egito', phoneCode: '+20', nationality: 'Egípcia', flag: '🇪🇬' },
  { code: 'MA', name: 'Marrocos', phoneCode: '+212', nationality: 'Marroquina', flag: '🇲🇦' },
  { code: 'TN', name: 'Tunísia', phoneCode: '+216', nationality: 'Tunisina', flag: '🇹🇳' },
  { code: 'DZ', name: 'Argélia', phoneCode: '+213', nationality: 'Argelina', flag: '🇩🇿' },
  { code: 'LY', name: 'Líbia', phoneCode: '+218', nationality: 'Líbia', flag: '🇱🇾' },
  { code: 'SD', name: 'Sudão', phoneCode: '+249', nationality: 'Sudanesa', flag: '🇸🇩' },
  { code: 'ET', name: 'Etiópia', phoneCode: '+251', nationality: 'Etíope', flag: '🇪🇹' },
  { code: 'GH', name: 'Gana', phoneCode: '+233', nationality: 'Ganesa', flag: '🇬🇭' },
  { code: 'CI', name: 'Costa do Marfim', phoneCode: '+225', nationality: 'Marfinense', flag: '🇨🇮' },
  { code: 'SN', name: 'Senegal', phoneCode: '+221', nationality: 'Senegalesa', flag: '🇸🇳' },
  { code: 'ML', name: 'Mali', phoneCode: '+223', nationality: 'Maliana', flag: '🇲🇱' },
  { code: 'BF', name: 'Burkina Faso', phoneCode: '+226', nationality: 'Burkinabé', flag: '🇧🇫' },
  { code: 'NE', name: 'Níger', phoneCode: '+227', nationality: 'Nigerina', flag: '🇳🇪' },
  { code: 'TD', name: 'Chade', phoneCode: '+235', nationality: 'Chadiana', flag: '🇹🇩' },
  { code: 'CM', name: 'Camarões', phoneCode: '+237', nationality: 'Camaronense', flag: '🇨🇲' },
  { code: 'CF', name: 'República Centro-Africana', phoneCode: '+236', nationality: 'Centro-africana', flag: '🇨🇫' },
  { code: 'CD', name: 'República Democrática do Congo', phoneCode: '+243', nationality: 'Congolesa', flag: '🇨🇩' },
  { code: 'CG', name: 'República do Congo', phoneCode: '+242', nationality: 'Congolesa', flag: '🇨🇬' },
  { code: 'GA', name: 'Gabão', phoneCode: '+241', nationality: 'Gabonesa', flag: '🇬🇦' },
  { code: 'TZ', name: 'Tanzânia', phoneCode: '+255', nationality: 'Tanzaniana', flag: '🇹🇿' },
  { code: 'UG', name: 'Uganda', phoneCode: '+256', nationality: 'Ugandesa', flag: '🇺🇬' },
  { code: 'RW', name: 'Ruanda', phoneCode: '+250', nationality: 'Ruandesa', flag: '🇷🇼' },
  { code: 'BI', name: 'Burundi', phoneCode: '+257', nationality: 'Burundesa', flag: '🇧🇮' },
  { code: 'MW', name: 'Malawi', phoneCode: '+265', nationality: 'Malawiana', flag: '🇲🇼' },
  { code: 'ZM', name: 'Zâmbia', phoneCode: '+260', nationality: 'Zambiana', flag: '🇿🇲' },
  { code: 'ZW', name: 'Zimbábue', phoneCode: '+263', nationality: 'Zimbabuense', flag: '🇿🇼' },
  { code: 'BW', name: 'Botsuana', phoneCode: '+267', nationality: 'Botsuanesa', flag: '🇧🇼' },
  { code: 'NA', name: 'Namíbia', phoneCode: '+264', nationality: 'Namibiana', flag: '🇳🇦' },
  { code: 'SZ', name: 'Eswatini', phoneCode: '+268', nationality: 'Suazi', flag: '🇸🇿' },
  { code: 'LS', name: 'Lesoto', phoneCode: '+266', nationality: 'Lesotiana', flag: '🇱🇸' },
  { code: 'MG', name: 'Madagáscar', phoneCode: '+261', nationality: 'Malgaxe', flag: '🇲🇬' },
  { code: 'MU', name: 'Maurícia', phoneCode: '+230', nationality: 'Mauriciana', flag: '🇲🇺' },
  { code: 'SC', name: 'Seicheles', phoneCode: '+248', nationality: 'Seichelense', flag: '🇸🇨' },
  { code: 'KM', name: 'Comores', phoneCode: '+269', nationality: 'Comorense', flag: '🇰🇲' },
  { code: 'DJ', name: 'Djibuti', phoneCode: '+253', nationality: 'Djibutiana', flag: '🇩🇯' },
  { code: 'SO', name: 'Somália', phoneCode: '+252', nationality: 'Somali', flag: '🇸🇴' },
  { code: 'ER', name: 'Eritreia', phoneCode: '+291', nationality: 'Eritreia', flag: '🇪🇷' },
  { code: 'SS', name: 'Sudão do Sul', phoneCode: '+211', nationality: 'Sul-sudanesa', flag: '🇸🇸' },
  { code: 'LR', name: 'Libéria', phoneCode: '+231', nationality: 'Liberiana', flag: '🇱🇷' },
  { code: 'SL', name: 'Serra Leoa', phoneCode: '+232', nationality: 'Serra-leonesa', flag: '🇸🇱' },
  { code: 'GN', name: 'Guiné', phoneCode: '+224', nationality: 'Guineense', flag: '🇬🇳' },
  { code: 'TG', name: 'Togo', phoneCode: '+228', nationality: 'Togolesa', flag: '🇹🇬' },
  { code: 'BJ', name: 'Benim', phoneCode: '+229', nationality: 'Beninense', flag: '🇧🇯' },
  { code: 'MR', name: 'Mauritânia', phoneCode: '+222', nationality: 'Mauritana', flag: '🇲🇷' },
  { code: 'GM', name: 'Gâmbia', phoneCode: '+220', nationality: 'Gambiana', flag: '🇬🇲' },

  // Europa
  { code: 'PT', name: 'Portugal', phoneCode: '+351', nationality: 'Portuguesa', flag: '🇵🇹' },
  { code: 'BR', name: 'Brasil', phoneCode: '+55', nationality: 'Brasileira', flag: '🇧🇷' },
  { code: 'ES', name: 'Espanha', phoneCode: '+34', nationality: 'Espanhola', flag: '🇪🇸' },
  { code: 'FR', name: 'França', phoneCode: '+33', nationality: 'Francesa', flag: '🇫🇷' },
  { code: 'IT', name: 'Itália', phoneCode: '+39', nationality: 'Italiana', flag: '🇮🇹' },
  { code: 'DE', name: 'Alemanha', phoneCode: '+49', nationality: 'Alemã', flag: '🇩🇪' },
  { code: 'GB', name: 'Reino Unido', phoneCode: '+44', nationality: 'Britânica', flag: '🇬🇧' },
  { code: 'NL', name: 'Países Baixos', phoneCode: '+31', nationality: 'Holandesa', flag: '🇳🇱' },
  { code: 'BE', name: 'Bélgica', phoneCode: '+32', nationality: 'Belga', flag: '🇧🇪' },
  { code: 'CH', name: 'Suíça', phoneCode: '+41', nationality: 'Suíça', flag: '🇨🇭' },
  { code: 'AT', name: 'Áustria', phoneCode: '+43', nationality: 'Austríaca', flag: '🇦🇹' },
  { code: 'SE', name: 'Suécia', phoneCode: '+46', nationality: 'Sueca', flag: '🇸🇪' },
  { code: 'NO', name: 'Noruega', phoneCode: '+47', nationality: 'Norueguesa', flag: '🇳🇴' },
  { code: 'DK', name: 'Dinamarca', phoneCode: '+45', nationality: 'Dinamarquesa', flag: '🇩🇰' },
  { code: 'FI', name: 'Finlândia', phoneCode: '+358', nationality: 'Finlandesa', flag: '🇫🇮' },
  { code: 'PL', name: 'Polónia', phoneCode: '+48', nationality: 'Polaca', flag: '🇵🇱' },
  { code: 'CZ', name: 'República Checa', phoneCode: '+420', nationality: 'Checa', flag: '🇨🇿' },
  { code: 'HU', name: 'Hungria', phoneCode: '+36', nationality: 'Húngara', flag: '🇭🇺' },
  { code: 'RO', name: 'Roménia', phoneCode: '+40', nationality: 'Romena', flag: '🇷🇴' },
  { code: 'BG', name: 'Bulgária', phoneCode: '+359', nationality: 'Búlgara', flag: '🇧🇬' },
  { code: 'GR', name: 'Grécia', phoneCode: '+30', nationality: 'Grega', flag: '🇬🇷' },
  { code: 'TR', name: 'Turquia', phoneCode: '+90', nationality: 'Turca', flag: '🇹🇷' },
  { code: 'RU', name: 'Rússia', phoneCode: '+7', nationality: 'Russa', flag: '🇷🇺' },
  { code: 'UA', name: 'Ucrânia', phoneCode: '+380', nationality: 'Ucraniana', flag: '🇺🇦' },

  // América
  { code: 'US', name: 'Estados Unidos', phoneCode: '+1', nationality: 'Americana', flag: '🇺🇸' },
  { code: 'CA', name: 'Canadá', phoneCode: '+1', nationality: 'Canadiana', flag: '🇨🇦' },
  { code: 'MX', name: 'México', phoneCode: '+52', nationality: 'Mexicana', flag: '🇲🇽' },
  { code: 'AR', name: 'Argentina', phoneCode: '+54', nationality: 'Argentina', flag: '🇦🇷' },
  { code: 'CL', name: 'Chile', phoneCode: '+56', nationality: 'Chilena', flag: '🇨🇱' },
  { code: 'CO', name: 'Colômbia', phoneCode: '+57', nationality: 'Colombiana', flag: '🇨🇴' },
  { code: 'PE', name: 'Peru', phoneCode: '+51', nationality: 'Peruana', flag: '🇵🇪' },
  { code: 'VE', name: 'Venezuela', phoneCode: '+58', nationality: 'Venezuelana', flag: '🇻🇪' },
  { code: 'EC', name: 'Equador', phoneCode: '+593', nationality: 'Equatoriana', flag: '🇪🇨' },
  { code: 'BO', name: 'Bolívia', phoneCode: '+591', nationality: 'Boliviana', flag: '🇧🇴' },
  { code: 'PY', name: 'Paraguai', phoneCode: '+595', nationality: 'Paraguaia', flag: '🇵🇾' },
  { code: 'UY', name: 'Uruguai', phoneCode: '+598', nationality: 'Uruguaia', flag: '🇺🇾' },
  { code: 'GY', name: 'Guiana', phoneCode: '+592', nationality: 'Guianesa', flag: '🇬🇾' },
  { code: 'SR', name: 'Suriname', phoneCode: '+597', nationality: 'Surinamesa', flag: '🇸🇷' },
  { code: 'GF', name: 'Guiana Francesa', phoneCode: '+594', nationality: 'Guianense', flag: '🇬🇫' },

  // Ásia
  { code: 'CN', name: 'China', phoneCode: '+86', nationality: 'Chinesa', flag: '🇨🇳' },
  { code: 'JP', name: 'Japão', phoneCode: '+81', nationality: 'Japonesa', flag: '🇯🇵' },
  { code: 'KR', name: 'Coreia do Sul', phoneCode: '+82', nationality: 'Sul-coreana', flag: '🇰🇷' },
  { code: 'IN', name: 'Índia', phoneCode: '+91', nationality: 'Indiana', flag: '🇮🇳' },
  { code: 'TH', name: 'Tailândia', phoneCode: '+66', nationality: 'Tailandesa', flag: '🇹🇭' },
  { code: 'VN', name: 'Vietname', phoneCode: '+84', nationality: 'Vietnamita', flag: '🇻🇳' },
  { code: 'ID', name: 'Indonésia', phoneCode: '+62', nationality: 'Indonésia', flag: '🇮🇩' },
  { code: 'MY', name: 'Malásia', phoneCode: '+60', nationality: 'Malaia', flag: '🇲🇾' },
  { code: 'SG', name: 'Singapura', phoneCode: '+65', nationality: 'Singapurense', flag: '🇸🇬' },
  { code: 'PH', name: 'Filipinas', phoneCode: '+63', nationality: 'Filipina', flag: '🇵🇭' },
  { code: 'BD', name: 'Bangladeche', phoneCode: '+880', nationality: 'Bangladechiana', flag: '🇧🇩' },
  { code: 'PK', name: 'Paquistão', phoneCode: '+92', nationality: 'Paquistanesa', flag: '🇵🇰' },
  { code: 'LK', name: 'Sri Lanka', phoneCode: '+94', nationality: 'Cingalesa', flag: '🇱🇰' },
  { code: 'MM', name: 'Myanmar', phoneCode: '+95', nationality: 'Birmanesa', flag: '🇲🇲' },
  { code: 'KH', name: 'Camboja', phoneCode: '+855', nationality: 'Cambojana', flag: '🇰🇭' },
  { code: 'LA', name: 'Laos', phoneCode: '+856', nationality: 'Laosiana', flag: '🇱🇦' },
  { code: 'BN', name: 'Brunei', phoneCode: '+673', nationality: 'Bruneiana', flag: '🇧🇳' },
  { code: 'MN', name: 'Mongólia', phoneCode: '+976', nationality: 'Mongol', flag: '🇲🇳' },
  { code: 'KZ', name: 'Cazaquistão', phoneCode: '+7', nationality: 'Cazaque', flag: '🇰🇿' },
  { code: 'UZ', name: 'Uzbequistão', phoneCode: '+998', nationality: 'Uzbeque', flag: '🇺🇿' },
  { code: 'KG', name: 'Quirguistão', phoneCode: '+996', nationality: 'Quirguiz', flag: '🇰🇬' },
  { code: 'TJ', name: 'Tajiquistão', phoneCode: '+992', nationality: 'Tajique', flag: '🇹🇯' },
  { code: 'TM', name: 'Turquemenistão', phoneCode: '+993', nationality: 'Turcomena', flag: '🇹🇲' },
  { code: 'AF', name: 'Afeganistão', phoneCode: '+93', nationality: 'Afegã', flag: '🇦🇫' },
  { code: 'IR', name: 'Irão', phoneCode: '+98', nationality: 'Iraniana', flag: '🇮🇷' },
  { code: 'IQ', name: 'Iraque', phoneCode: '+964', nationality: 'Iraquiana', flag: '🇮🇶' },
  { code: 'SY', name: 'Síria', phoneCode: '+963', nationality: 'Síria', flag: '🇸🇾' },
  { code: 'LB', name: 'Líbano', phoneCode: '+961', nationality: 'Libanesa', flag: '🇱🇧' },
  { code: 'JO', name: 'Jordânia', phoneCode: '+962', nationality: 'Jordana', flag: '🇯🇴' },
  { code: 'IL', name: 'Israel', phoneCode: '+972', nationality: 'Israelita', flag: '🇮🇱' },
  { code: 'PS', name: 'Palestina', phoneCode: '+970', nationality: 'Palestiniana', flag: '🇵🇸' },
  { code: 'SA', name: 'Arábia Saudita', phoneCode: '+966', nationality: 'Saudita', flag: '🇸🇦' },
  { code: 'AE', name: 'Emirados Árabes Unidos', phoneCode: '+971', nationality: 'Emiratense', flag: '🇦🇪' },
  { code: 'QA', name: 'Catar', phoneCode: '+974', nationality: 'Catariana', flag: '🇶🇦' },
  { code: 'BH', name: 'Barém', phoneCode: '+973', nationality: 'Baremita', flag: '🇧🇭' },
  { code: 'KW', name: 'Kuwait', phoneCode: '+965', nationality: 'Kuwaitiana', flag: '🇰🇼' },
  { code: 'OM', name: 'Omã', phoneCode: '+968', nationality: 'Omanense', flag: '🇴🇲' },
  { code: 'YE', name: 'Iémen', phoneCode: '+967', nationality: 'Iemenita', flag: '🇾🇪' },

  // Oceania
  { code: 'AU', name: 'Austrália', phoneCode: '+61', nationality: 'Australiana', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nova Zelândia', phoneCode: '+64', nationality: 'Neozelandesa', flag: '🇳🇿' },
  { code: 'FJ', name: 'Fiji', phoneCode: '+679', nationality: 'Fijiana', flag: '🇫🇯' },
  { code: 'PG', name: 'Papua Nova Guiné', phoneCode: '+675', nationality: 'Papua-nova-guineense', flag: '🇵🇬' },
  { code: 'SB', name: 'Ilhas Salomão', phoneCode: '+677', nationality: 'Salomónica', flag: '🇸🇧' },
  { code: 'VU', name: 'Vanuatu', phoneCode: '+678', nationality: 'Vanuatuense', flag: '🇻🇺' },
  { code: 'NC', name: 'Nova Caledónia', phoneCode: '+687', nationality: 'Neocaledónia', flag: '🇳🇨' },
  { code: 'PF', name: 'Polinésia Francesa', phoneCode: '+689', nationality: 'Polinésia', flag: '🇵🇫' },
  { code: 'WS', name: 'Samoa', phoneCode: '+685', nationality: 'Samoana', flag: '🇼🇸' },
  { code: 'TO', name: 'Tonga', phoneCode: '+676', nationality: 'Tonganesa', flag: '🇹🇴' },
  { code: 'KI', name: 'Kiribati', phoneCode: '+686', nationality: 'Kiribatiana', flag: '🇰🇮' },
  { code: 'TV', name: 'Tuvalu', phoneCode: '+688', nationality: 'Tuvaluana', flag: '🇹🇻' },
  { code: 'NR', name: 'Nauru', phoneCode: '+674', nationality: 'Nauruana', flag: '🇳🇷' },
  { code: 'PW', name: 'Palau', phoneCode: '+680', nationality: 'Palauana', flag: '🇵🇼' },
  { code: 'FM', name: 'Micronésia', phoneCode: '+691', nationality: 'Micronésia', flag: '🇫🇲' },
  { code: 'MH', name: 'Ilhas Marshall', phoneCode: '+692', nationality: 'Marshallense', flag: '🇲🇭' },
]

// Função para encontrar país por código de telefone
export const findCountryByPhoneCode = (phoneCode: string): Country | undefined => {
  return countries.find(country => country.phoneCode === phoneCode)
}

// Função para encontrar país por código ISO
export const findCountryByCode = (code: string): Country | undefined => {
  return countries.find(country => country.code === code)
}

// Função para obter países ordenados por nome
export const getSortedCountries = (): Country[] => {
  return [...countries].sort((a, b) => a.name.localeCompare(b.name, 'pt'))
}

// Função para obter países africanos (prioridade para São Tomé e Príncipe)
export const getAfricanCountries = (): Country[] => {
  const africanCountries = countries.filter(country => 
    ['ST', 'AO', 'MZ', 'CV', 'GW', 'GQ', 'ZA', 'NG', 'KE', 'EG', 'MA', 'TN', 'DZ', 'LY', 'SD', 'ET', 'GH', 'CI', 'SN', 'ML', 'BF', 'NE', 'TD', 'CM', 'CF', 'CD', 'CG', 'GA', 'TZ', 'UG', 'RW', 'BI', 'MW', 'ZM', 'ZW', 'BW', 'NA', 'SZ', 'LS', 'MG', 'MU', 'SC', 'KM', 'DJ', 'SO', 'ER', 'SS', 'LR', 'SL', 'GN', 'TG', 'BJ', 'MR', 'GM'].includes(country.code)
  )
  
  // Colocar São Tomé e Príncipe primeiro
  const stp = africanCountries.find(country => country.code === 'ST')
  const others = africanCountries.filter(country => country.code !== 'ST')
  
  return stp ? [stp, ...others] : africanCountries
}











